
export enum StorageKeys {
    devices = 'devices',
    address = 'address'
}